export const setMetalData = (data) => {
    return {
        type: "SET_METALDATA",
        payload: data,
    };
}


